import React from 'react'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-duotone-svg-icons'

class ContentDossierFavorite extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            favorite: this.props.favorite === true ? true : false,
        }
        this.favorOrUnfavorDossier = this.favorOrUnfavorDossier.bind(this)
    }

    favor() {
        let url = this.props.kedo
            .api()
            .getContentDossierFavoriteEndpoint(this.props.dossier.id)
        this.setState({ loading: true })
        let data = { content_dossier: this.props.dossier.id }

        this.props.kedo
            .api()
            .post(url)
            .then((response) =>
                this.setState({
                    favorite: true,
                    loading: false,
                })
            )
    }

    unfavor() {
        let url = this.props.kedo
            .api()
            .getContentDossierFavoriteEndpoint(this.props.dossier.id)
        this.setState({ loading: true })
        this.props.kedo
            .api()
            .delete(url)
            .then((response) =>
                this.setState({
                    favorite: false,
                    loading: false,
                })
            )
    }

    favorOrUnfavorDossier() {
        if (this.state.favorite === true) {
            return this.unfavor()
        } else {
            return this.favor()
        }
    }

    render() {
        return (
            <Button
                active={this.state.favorite}
                size={this.props.size}
                onClick={this.favorOrUnfavorDossier}
                variant="outline-primary"
                title={this.props.kedo.t('Favorite')}
            >
                <FontAwesomeIcon icon={faStar} />
            </Button>
        )
    }
}

export default ContentDossierFavorite
